import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import {Link} from 'react-router-dom';
import {SvgAssets} from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import { notificacion } from '../../utilitarios/util';
import { recuperarAcceso } from '../../store/sagas/authApi';
import Spinner from "../reusable/Loader";

function SendEmail ({ dadComponent }){
  const { loading, email, errorValidacion } = dadComponent.state;
  return(
    <div>
      <h4 className='title-2 text-center desktop' style={{color:c.azulClaro}}><SvgAssets icon="icon-lock-eye" className="mr-2" fill={c.azulClaro}/>Recuperar contraseña</h4>
      <div className="card card_container">
        <h4 className="text-center title-2 azul mobile"><SvgAssets icon="icon-lock-eye" className="icon-block" fill={c.azulClaro}/>Recuperar <br/> contraseña</h4>
        <form>
          <FormGroup>
            <Input className="azul" type="email" name="email" placeholder="Email" value={email} onChange={(e) => { let email = e.currentTarget.value; dadComponent.setEmail(email)}}
            onKeyPress={(e) => { if (e.which == 13 || e.which == 10) e.preventDefault();}}
            onKeyUp={(e) => e.keyCode == 13 && email != '' ? dadComponent.RecuperarContrasenia() : null} />
            {errorValidacion ? <FormFeedback>{errorValidacion}</FormFeedback> : null}
          </FormGroup>
        </form>
        <div className="text-center mt-5">
          <button className={`btn-block red${(email == "" ? " disabled" : "")}`}
          disabled={email == ""}
          // onClick={dadComponent.nextStep}
          onClick={() => dadComponent.RecuperarContrasenia()}
          >
            siguiente<SvgAssets className='svg-right' icon="icon-arrow-right" fill="#fff" />
          </button>
          <Link className="link-u mt-5 mobile" to={{pathname: '/', state: { step: 1 }}} style={{color:"#D7202C"}}>Iniciar sesión</Link>
        </div>
      </div>
      <div className="text-center mt-5">
        <Link className="link-u desktop" to={{pathname: '/', state: { step: 1 }}} style={{color:"#D7202C"}}>Iniciar sesión</Link>
      </div>
    </div>
  )
}

function Message ({ dadComponent }){
  const { email, errorValidacion } = dadComponent.state;
  return(
    <div>
      <h4 className='title-2 text-center desktop' style={{color:c.azulClaro}}><SvgAssets icon="icon-lock-eye" fill={c.azulClaro}/>Recuperar contraseña</h4>
      <div className="card card_container">
        <h4 className="text-center mobile title-2 azul">
          <SvgAssets icon="icon-lock-eye" className="icon-block" fill={c.azulClaro}/>
          Recuperar <br/> contraseña
        </h4>
        <p className="paragraph-1 text-center light mb-text">Hemos enviado un código de recuperación de contraseña a tu correo electrónico: <strong>{email}</strong></p>
        <div className="text-center mt-5">
          <button className='btn-block red'
          type="button"
          onClick={() => dadComponent.Entendido()}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  )
}

export class RecuperarContrasenia extends Component {
  static displayName = RecuperarContrasenia.name;

  constructor (props) {
    super(props);

    this.state = {
      step: 0,
      loading: false,
      errorValidacion: null,
      email: '',
    };
    // this.nextStep = this.nextStep.bind(this);
    // this.backStep = this.backStep.bind(this);
  }

  load = async () => {
    this.setState({
      loading: false,
      errorValidacion: null,
      email: ''
    })
  }

  componentDidMount(){
    window.scrollTo(0, 0)
    this.load();
  }

  nextStep() {
    this.setState({step: this.state.step + 1})
  }

  backStep() {
    this.setState({step: this.state.step - 1})
  }

  renderStep() {
    switch(this.state.step) {
      case 0:
        return <SendEmail dadComponent={this} />
      case 1:
        return <Message dadComponent={this} />
      default:
        return <SendEmail dadComponent={this} />
    }
  }

  render () {
    const { step, loading } = this.state;
    return (
      <Container className="py-5" id="mhw">
        <Spinner visible={loading} />
        <button className="btn-back mobile" 
            onClick={() => {step == 0 ? this.props.history.push('/') : this.backStep()}}
          >
              <SvgAssets icon="icon-back" fill="#fff" />
        </button>
        {this.renderStep()}
      </Container>
    );
  }
  setEmail = (value) => {
    this.setState({ email: value, errorValidacion: null })
  }
  RecuperarContrasenia = () => {
    let _email = this.state.email;
    if (_email == "" || _email == null) {
      this.setState({ errorValidacion: "Debe ingresar el correo electrónico." })
    } else {
      this.postRecuperarAcceso();
      // this.props.navigation.navigate('CodigoEnviado' );
    }
  }

  postRecuperarAcceso = async () => {
    let CorreoElectronico = this.state.email;
    this.setState({ loading: true });
    recuperarAcceso(CorreoElectronico)
      .then(result => {
        this.setState({ loading: false });
        console.log("Resultado===>", result);
        if (result.mo.type == "success") {
          this.setState({ loading: false, errorValidacion: "Su código fue enviado al correo electrónico" }, () =>{
            this.nextStep();
          });
          // this.props.navigation.navigate('CodigoEnviado', {
          //   email: CorreoElectronico
          // });
        } else {
          this.setState({ loading: false, errorValidacion: result.mo.listMessage.join(", ") });
        }
      }).catch((error) => {
        //console.log("postLogin ", error);
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });
  }

  Entendido() {
    this.setState({ loading: false, errorValidacion: "Su código fue enviado al correo electrónico" });
    this.props.history.push({
      pathname: '/verificar-correo-contrasenia',
      state: {
        email: this.state.email
      }
    });
  }
}
